var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { margin } from 'styled-system';
import { useAriaLive } from '@ally/use-aria-live';
import SpinnerBlack from '../svgs/SpinnerBlack';
import SpinnerWhite from '../svgs/SpinnerWhite';
const sizes = {
    large: '36px',
    small: '24px',
};
const Spinner = (_a) => {
    var { themeColor = 'dark', size = 'large', altText = 'Loading', disableAriaLiveAnnouncement = false } = _a, others = __rest(_a, ["themeColor", "size", "altText", "disableAriaLiveAnnouncement"]);
    const { announceAssertive } = useAriaLive();
    useEffect(() => {
        if (!disableAriaLiveAnnouncement) {
            announceAssertive(altText);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [altText]);
    const SpinnerSVG = themeColor === 'dark' ? SpinnerBlack : SpinnerWhite;
    return (React.createElement("div", Object.assign({ "aria-busy": true, "data-testid": "mui-loading-spinner" }, others),
        React.createElement(SpinnerSVG, { width: sizes[size], height: sizes[size] })));
};
const SpinnerWithMarginProps = styled(Spinner)(margin);
export { SpinnerWithMarginProps as Spinner, Spinner as SpinnerForProps };
//# sourceMappingURL=Spinner.js.map